import React, { FC, memo, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Link } from 'react-scroll';
import cn from 'classnames';

import { PathName } from 'appConstants';

import styles from './styles.module.scss';

interface ILinksHead {
  onBurgerChange: () => void;
  links?: { title: string; pathName: string; }[];
  isFooterLink?: boolean;
}

export const LinksHead:FC<ILinksHead> = memo(({ onBurgerChange, links, isFooterLink }) => {
  const { t: tHeader } = useTranslation('header');
  const { t: tFooter } = useTranslation('footer');
  const navigate = useNavigate();
  const { pathname: currentPath } = useLocation();
  const referralFromURL = window?.location?.search;

  const handleScrollToMainPage = useCallback(() => {
    onBurgerChange();
    if (currentPath !== PathName.Home) {
      navigate(`${PathName.Home}${referralFromURL}`);
    }
  }, [onBurgerChange, currentPath, navigate, referralFromURL]);

  return (
    <div className={styles.header_navigation}>
      {links?.map(({ pathName, title }, index) => (
        <Link
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          smooth
          offset={-100}
          to={pathName}
          onClick={handleScrollToMainPage}
          className={cn(styles.header_navigation_link, {
            [styles.active]: currentPath === pathName,
          })}
        >
          {isFooterLink ? tFooter(title) : tHeader(title)}
        </Link>
      ))}
    </div>
  );
});
